import { render, staticRenderFns } from "./KeyDates.vue?vue&type=template&id=65aa1046&scoped=true&"
import script from "./KeyDates.vue?vue&type=script&lang=js&"
export * from "./KeyDates.vue?vue&type=script&lang=js&"
import style0 from "./KeyDates.vue?vue&type=style&index=0&id=65aa1046&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aa1046",
  null
  
)

export default component.exports